import React from "react";
import { Clock, FileText } from "lucide-react";

const TIME = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    const diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 60) return "just now";
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return d.toLocaleDateString();
  } catch { return ""; }
};

export const RecentReportsList = ({ reports = [], onOpen }) => {
  if (!reports.length) {
    return (
      <div data-testid="recent-empty" className="rounded-xl border border-dashed border-slate-200 bg-slate-50/60 p-6 text-center">
        <FileText className="w-5 h-5 text-slate-300 mx-auto" />
        <p className="mt-2 text-xs text-slate-500">No reports generated yet.</p>
      </div>
    );
  }
  return (
    <div data-testid="recent-reports-list" className="rounded-xl border border-slate-200 bg-white divide-y divide-slate-100">
      {reports.map((r) => (
        <button
          key={r.report_id}
          data-testid={`recent-${r.report_id}`}
          onClick={() => onOpen?.(r.report_id)}
          className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left hover:bg-slate-50 transition-colors"
        >
          <div className="min-w-0 flex-1">
            <div className="text-sm font-medium text-slate-900 truncate">{r.report_name}</div>
            <div className="text-[11px] text-slate-500 mt-0.5">
              {r.filters?.project_id || "All Projects"} · {(r.date_range?.from || "").slice(0, 10)} → {(r.date_range?.to || "").slice(0, 10)}
            </div>
          </div>
          <div className="text-[11px] text-slate-400 inline-flex items-center gap-1 flex-shrink-0">
            <Clock className="w-3 h-3" />
            {TIME(r.generated_at)}
          </div>
        </button>
      ))}
    </div>
  );
};

export default RecentReportsList;
